/**
 * Website Builder permissions.
 *
 * The API defines `create|read|update|delete:Website Builder` (en_module `Website Builder`,
 * key `WebsiteBuilder`) but does not seed them yet, so every check also accepts the seeded
 * legacy "Website" (landing pages) permission. Once the API seeds the module, drop the second
 * entry of each array; nothing else changes.
 */
export const WB_PERMISSION_MODULE = 'Website Builder';
export const WB_LEGACY_MODULE = 'Website';

/** en_module names for `permissionsGuard` route data (ANY match). */
export const WB_ROUTE_PERMISSION_MODULES: string[] = [
  WB_PERMISSION_MODULE,
  WB_LEGACY_MODULE,
];

/** en_name lists for `*appHasPermission` / `PermissionsService.hasPermission` (ANY match). */
export const WB_PERMISSIONS = {
  read: ['read:Website Builder', 'read:Landing Pages'],
  create: ['create:Website Builder', 'create:Landing Pages'],
  update: ['update:Website Builder', 'update:Landing Pages'],
  delete: ['delete:Website Builder', 'delete:Landing Pages Data'],
} as const;

export type WbPermissionAction = keyof typeof WB_PERMISSIONS;
